import { Button } from '@creditornot/cb-button';
import { Pencil } from '@creditornot/cb-icons';
import { InputSwitch } from '@creditornot/cb-switch';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { DeliveryAreaValue } from 'apis/delivery-settings-api/types';
import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';

import DeliveryAreasTable from './DeliveryAreasTable';
import DeliveryFee from './DeliveryFee';

type Props = {
  deliveryAreas: DeliveryAreaValue[];
  currency: Currency;
  hideToggles: boolean;
  onEditClick?: () => void;
};

const Root = styled.div``;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 36px; /* preserve height when there is no button */
`;

const EditButton = styled(Button)``;

const AreasTable = styled(DeliveryAreasTable)`
  margin-block-start: 16px;
`;

const DeliveryAreasView = ({ deliveryAreas, currency, hideToggles, onEditClick }: Props) => {
  return (
    <Root>
      {!!onEditClick && (
        <ButtonContainer>
          <EditButton variant="lightBlue" size="small" onClick={onEditClick} icon={<Pencil />}>
            <FormattedMessage id="state.edit" />
          </EditButton>
        </ButtonContainer>
      )}

      <AreasTable
        rows={deliveryAreas.map(({ name, deliveryBaseFee, distanceBasedPricing, minBasketSize, disabled }) => ({
          areaName: name,
          isDisabledArea: disabled,
          deliveryFee: (
            <DeliveryFee
              currency={currency}
              deliveryBaseFee={deliveryBaseFee}
              distanceBasedPricing={distanceBasedPricing}
            />
          ),
          minBasketSize:
            minBasketSize === undefined ? (
              '-'
            ) : (
              <MonetaryAmount amount={convertMonetaryIntToDecimal(minBasketSize, currency)} currency={currency} />
            ),
          enabled: <InputSwitch disabled checked={!disabled} />,
        }))}
        hideEnabledControl={hideToggles}
      />
    </Root>
  );
};

export default DeliveryAreasView;
